import { find } from "lodash"
import PropTypes from "prop-types"
import React, { Component } from "react"

import AccountSelectHOC from "../../AccountSelectHOC"
import { formatAccount } from "../../helpers"
import AccountDropdown from "../Dropdown/AccountDropdown"

class CombinedAccountSelect extends Component {
  static propTypes = {
    accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
    upsell: PropTypes.object.isRequired,
    activeAccount: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeAccount: null,
      upsell: {},
      accounts: [],
    }
  }

  static getDerivedStateFromProps({ format, accounts, upsell, activeAccount }) {
    const url = format || ""
    const current =
      find(accounts, {
        account_id: parseInt(activeAccount, 10),
      }) || accounts[0]
    return {
      activeAccount: formatAccount(current, url),
      accounts: accounts.map(acc => formatAccount(acc, url)),
      upsell,
    }
  }

  render() {
    const { accounts, activeAccount, upsell } = this.state
    if (!activeAccount) return null
    return (
      <AccountDropdown
        activeAccount={activeAccount}
        accountsList={accounts}
        upsell={upsell}
      />
    )
  }
}

export default AccountSelectHOC(CombinedAccountSelect)
